module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-00.1@2x.2581183b.jpg";